import { createAPIRequest, ListResponse } from '@tlx/astro-shared';
import { useState } from 'react';
import { KeyedMutator } from 'swr';
import { OverviewDTO } from '@Models/Overview.types.ts';
import { APIUrls } from '@Util/urls.ts';

export enum DeleteStatus {
    IDLE,
    LOADING,
    SUCCESS,
    ERROR,
}
export function useDeleteVoucher(mutate: KeyedMutator<ListResponse<OverviewDTO>[]>) {
    const [deleteStatus, setDeleteStatus] = useState<DeleteStatus>(DeleteStatus.IDLE);

    const deleteVoucher = async (id: number) => {
        try {
            setDeleteStatus(DeleteStatus.LOADING);
            const URL = `${APIUrls.SALARY_TRANSACTION}/${id}`;
            const request = createAPIRequest(URL, {
                method: 'DELETE',
            });
            const response = await fetch(request, { method: 'DELETE' });
            if (!response.ok) {
                throw new Error('Failed to delete voucher');
            }
            setDeleteStatus(DeleteStatus.SUCCESS);
            mutate(); // Use mutate function here
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
            setDeleteStatus(DeleteStatus.ERROR);
        }
    };
    const resetStatus = () => setDeleteStatus(DeleteStatus.IDLE);

    return { deleteVoucher, deleteStatus, resetStatus };
}
